export default __webpack_public_path__ + "static/media/work-day-scheduler.bc731b1a.png";